import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class ChatService extends AxiosBase {
  getChatData = async (startDate, endDate, page, navigate) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.CHAT.GET_CHAT_DATA}?startDate=${startDate}&endDate=${endDate}&page=${page}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  feedback = async (body, navigate, id) => {
    try {
      const response = await this.requests.post(
        `/chat/${id}${API_ROUTES.CHAT.FEEDBACK}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  uploadImageRegignation = async (body, navigate, sendMessage) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.CHAT.UPLOAD_IMAGE_REGIGNATION}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  getChatSearchData = async (searchText) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.CHAT.CHAT_SEARCH}?q=${searchText}`
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
}
